export default {
  component: () => import('./page.vue'),
  path: '/archives',
  name: 'archives',
  meta: {
    title: '健康档案',
    auth: true,
  },
};
